import React from 'react'
import styled, { useTheme } from '~/ui/styled'
import { BetweenFlex, Text, IconFont, AroundFlex, CenterFlex } from '~components/El'
import { OvalBadge } from '~widgets/badge';

type TabOption =  { label: string; value: string, icon?: string, iconColor?: string, iconSize?: number,  count?:  number }

interface TabsProps {
  tabs: TabOption[]
  active: string
  onChange: (value: string | { label: string; value: string, icon?: string, iconColor?: string, iconSize?: number }) => void
  height?: number
}

const TabsContainer = styled(AroundFlex)`
  flex-direction: row;
  width: 100%;
  padding: 3px;
  height: auto;
  /* border-radius: 8px; */ 
  background-color: ${({ theme }) => theme.colors.blockBackground};
`

const TabItem = styled(CenterFlex)<{ active: boolean }>`
  /* flex: 1; */
  width: auto;
  flex-direction: row;
  height: 36px;
  /* border-radius: 6px; */
  justify-content: center;
  align-items: center;
  border-bottom:3px solid ${({ active, theme }) => (active ? theme.colors.primary : 'transparent')};
  /* color: ${({ active, theme }) => (active ? theme.colors.primary : theme.colors.textLight )}; */
`

const TabText = styled(Text)<{ active: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ active, theme }) => (active ? theme.colors.primary : theme.colors.text)};
  font-weight: ${({ active }) => (active ? 600 : 400)};
`

export const TextTabs: React.FC<TabsProps> = ({ tabs, active, onChange, height = 40 }) => {
  const theme = useTheme()
  return (
    <TabsContainer theme={theme}>
      {tabs.map((item, index) => {
        const label = typeof item === 'string' ? item : item.label
        const value = typeof item === 'string' ? item : item.value
        const isActive = active === value
        const icon = typeof item === 'string' ? "" : item.icon
        const iconSize = typeof item === 'string' ? 0 : (item.iconSize || 16)
        return (
          <TabItem
            key={index}
            active={isActive}
            height={height}
            onClick={() => onChange(item)}
          >
            {icon ? (
              <IconFont
                name={icon}
                color={isActive ? theme.colors.textLight : theme.colors.text}
                size={iconSize}
                style={{ marginRight: 10 }}
              />
            ) : null}
            <TabText active={isActive}>{label}</TabText>
            <OvalBadge value={item.count} top="0px" right="-18px" />
          </TabItem>
        )
      })}
    </TabsContainer>
  )
}
